import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DraftTable from "./DraftTable";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import ItemCount from "../../utils/ItemCount";

const BuyerDashboardPending = () => {
  const [tenders, setTenders] = useState();
  const [vq, setVq] = useState();
  const [draft, setDraft] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState("VQ");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);
  const navigate = useNavigate();

  const [vendorCount, setVendorCount] = useState(0);

  useEffect(() => {
    const getVendorTenders = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setVendorCount(res.data.length);
          localStorage.removeItem("action")
        } catch (error) {
          console.log(error);
        }
      };
      getVendorTenders();

  }, [])

  const handleInDrafts = async () => {
    setDraft(true);
    setIsLoading(true);
    setActiveTab("drafts");
  };

  useEffect(() => {
    if (activeTab !== "drafts" && activeTab !== "VQ") {
      const getTenders = async () => {
        setTenders();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}&status=${activeTab}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getTenders();
    }
  }, [activeTab]);

  const getVendorTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsVQLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (activeTab === "VQ") {
      getVendorTenders();
    }
  }, [activeTab]);

  useEffect(() => {
    if(localStorage.getItem("pending")){
      setActiveTab("VQ");
      setPendingActions(true)
      localStorage.removeItem("pending")
    }
  }, [])

  return (
    <Box sx={{ textAlign: "center" }}>
      
          <Typography variant="h5" textAlign={"start"} fontWeight={"bold"}>
            My Pending Actions
          </Typography>
          <Box
            className="dashboard-container"
            sx={{ height: 400, width: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
                borderBottom: "1px solid #D1D1D1",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <Button
                  className={`dashboard-btns ${
                    activeTab === "VQ" ? "active" : ""
                  }`}
                  onClick={() => {
                    setDraft(false);
                    setActiveTab("VQ");
                    setIsLoading(true);
                  }}
                >
                  Vendor Qualification <ItemCount count={vendorCount} />
                </Button>
                <Button
                  className={`dashboard-btns ${
                    activeTab === "REWORK" ? "active" : ""
                  }`}
                  onClick={() => {
                    setDraft(false);
                    localStorage.setItem("activeTab", "REWORK")
                    navigate("/dashboard")
                  }}
                >
                  Tender Rework
                </Button>
              </Box>
            </Box>
            <VQTable
              vendors={vq}
              activeTab={activeTab}
              isLoading={isVQLoading}
              getVendorTenders={getVendorTenders}
            />
          </Box>
        
    </Box>
  );
};

export default BuyerDashboardPending;
